import AutopilotDashboard from "./AutopilotDashboard";

function App() {
  return <AutopilotDashboard />;
}

export default App;
